export const FLASHING_INTERVAL = 250;
